document.addEventListener('DOMContentLoaded', () => {
  // Marquee: clone sets to fill the viewport for seamless loop
  document.querySelectorAll('.announcement__track').forEach((track) => {
    const firstSet = track.querySelector('.announcement__set');
    if (!firstSet) return;

    const setWidth = firstSet.offsetWidth;
    if (setWidth === 0) return;

    const minFill = window.innerWidth * 2 + setWidth;
    const setsNeeded = Math.ceil(minFill / setWidth);

    for (let i = 1; i < setsNeeded; i++) {
      const clone = firstSet.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    }

    track.style.setProperty('--announcement-set-width', `${setWidth}px`);
  });

  // Rotator: cycle one item at a time with a horizontal slide
  document.querySelectorAll('.announcement__rotator').forEach((rotator) => {
    const items = Array.from(rotator.querySelectorAll('.announcement__rotator-item'));
    if (items.length <= 1) return;

    const interval = parseInt(rotator.dataset.interval, 10) || 4000;
    const transitionMs = 450;
    let current = 0;

    setInterval(() => {
      const prev = current;
      current = (current + 1) % items.length;

      items[prev].classList.remove('announcement__rotator-item--active');
      items[prev].classList.add('announcement__rotator-item--exit');
      items[current].classList.add('announcement__rotator-item--active');

      // After exit transition completes, snap prev back to the right (no animation)
      setTimeout(() => {
        items[prev].classList.remove('announcement__rotator-item--exit');
        items[prev].style.transitionDuration = '0ms';
        requestAnimationFrame(() => requestAnimationFrame(() => {
          items[prev].style.transitionDuration = '';
        }));
      }, transitionMs + 50);
    }, interval);
  });
});
